var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCandidateApplicationsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 297,
    viewBox: "0 0 456 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.23 0.222168H63.5366V251.308H456.23V0.222168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.001 31.7148H74.7656V127.431H445.001V31.7148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.154 45.5405H166.858V50.0277H245.154V45.5405Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.765 61.9082H166.858V66.3953H287.765V61.9082Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.394 77.3291H166.858V81.8162H265.394V77.3291Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.382 92.6914H166.858V97.1785H224.382V92.6914Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.676 108.054H166.858V112.541H253.676V108.054Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 43.9448H131.172V53.5164H140.759V43.9448Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 59.3657H131.172V68.9373H140.759V59.3657Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 74.7866H131.172V84.3582H140.759V74.7866Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 90.2075H131.172V99.7791H140.759V90.2075Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 105.628H131.172V115.2H140.759V105.628Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.225 65.7471H361.268V97.6524H393.225V65.7471Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.001 140.724H74.7656V236.44H445.001V140.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.271 149.231H147.684V158.803H157.271V149.231Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.759 149.231H131.172V158.803H140.759V149.231Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.726 170.162C290.804 165.223 286.75 161.047 281.896 157.977C277.043 154.908 271.528 153.032 265.807 152.504C260.086 151.976 254.321 152.812 248.986 154.942C243.651 157.072 238.899 160.436 235.12 164.757L232.784 162.719C236.885 158.028 242.043 154.376 247.833 152.063C253.624 149.75 259.882 148.843 266.092 149.415C272.302 149.988 278.288 152.024 283.556 155.357C288.825 158.689 293.225 163.223 296.397 168.584L293.726 170.162Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.189 210.516L292.614 208.787C296.428 203.108 298.556 196.469 298.752 189.635C298.949 182.801 297.207 176.05 293.727 170.162L296.397 168.584C300.176 174.976 302.068 182.305 301.854 189.724C301.64 197.143 299.33 204.351 295.189 210.516V210.516Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.107 214.831C226.693 207.68 223.12 198.434 223.061 188.836C223.001 179.237 226.459 169.948 232.784 162.719L235.12 164.757C229.294 171.417 226.109 179.975 226.164 188.817C226.218 197.659 229.51 206.176 235.418 212.764L233.107 214.831Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.466 227.934C256.925 227.929 251.447 226.761 246.389 224.503C241.331 222.246 236.806 218.95 233.107 214.831L235.418 212.764C239.108 216.879 243.69 220.098 248.815 222.175C253.94 224.252 259.473 225.132 264.991 224.748C270.509 224.365 275.866 222.727 280.654 219.961C285.441 217.195 289.532 213.373 292.614 208.787L295.189 210.516C291.587 215.879 286.717 220.273 281.01 223.311C275.302 226.349 268.933 227.937 262.466 227.934Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.225 169.971H361.268V201.876H393.225V169.971Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.798 190.709H129.84V222.615H161.798V190.709Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.063 0H63.3691V16.6557H456.063V0Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7664 11.6022C77.4741 11.6022 78.8585 10.2201 78.8585 8.51522C78.8585 6.81032 77.4741 5.42822 75.7664 5.42822C74.0587 5.42822 72.6743 6.81032 72.6743 8.51522C72.6743 10.2201 74.0587 11.6022 75.7664 11.6022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5032 11.6022C89.2109 11.6022 90.5953 10.2201 90.5953 8.51522C90.5953 6.81032 89.2109 5.42822 87.5032 5.42822C85.7955 5.42822 84.4111 6.81032 84.4111 8.51522C84.4111 10.2201 85.7955 11.6022 87.5032 11.6022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.24 11.6022C100.948 11.6022 102.332 10.2201 102.332 8.51522C102.332 6.81032 100.948 5.42822 99.24 5.42822C97.5323 5.42822 96.1479 6.81032 96.1479 8.51522C96.1479 10.2201 97.5323 11.6022 99.24 11.6022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1495 170.053L60.6425 229.997L74.1742 274.401L52.2659 279.414L31.0022 190.606L30.3576 275.833L2.65039 276.549L9.0939 225.7L12.3159 168.405L48.1495 170.053Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 274.633V286.059L12.6503 292.486C12.6503 292.486 11.2842 298.199 19.4808 296.771C27.6773 295.343 23.579 288.916 23.579 288.916L20.8468 283.203L19.4808 273.919L13.3334 274.633Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2082 273.552L67.1582 284.862L68.9199 291.094C68.9199 291.094 71.2247 296.49 63.0021 296.631C54.7795 296.772 57.6721 289.633 57.6721 289.633L59.3567 283.46L59.1022 274.011L65.2082 273.552Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0054 116.336C20.0054 116.336 31.69 111.068 37.1782 116.633C42.6664 122.198 22.4839 120.366 20.0054 116.336Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1817 91.3516C36.2551 84.4865 28.4865 84.1665 28.4865 84.1665C28.4865 84.1665 20.9164 83.1649 16.0602 93.6206C11.5339 103.366 5.28701 112.776 15.0545 115.057L16.8188 109.375L17.9115 115.48C19.3022 115.584 20.6973 115.608 22.0906 115.554C32.5508 115.204 42.5126 115.656 42.1919 111.772C41.7655 106.609 43.96 97.9572 40.1817 91.3516Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.953 106.261C21.953 106.261 23.7234 118.351 20.1826 119.816C16.6418 121.282 27.2641 127.51 27.2641 127.51H33.2835L37.1783 119.084C37.1783 119.084 33.6376 112.489 35.762 106.261C37.8865 100.033 21.953 106.261 21.953 106.261Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.953 106.261C21.953 106.261 23.7234 118.351 20.1826 119.816C16.6418 121.282 27.2641 127.51 27.2641 127.51H33.2835L37.1783 119.084C37.1783 119.084 33.6376 112.489 35.762 106.261C37.8865 100.033 21.953 106.261 21.953 106.261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4744 116.52C19.4744 116.52 23.3692 120.916 24.0774 121.649C24.7856 122.381 27.9723 126.411 34.6997 120.55C41.4272 114.688 42.1354 121.649 42.1354 121.649V165.613C42.1354 165.613 36.4701 163.048 31.8671 165.613C27.2641 168.177 17.704 164.88 17.704 164.88L15.9336 119.45L19.4744 116.52Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0752 116.52C22.0752 116.52 12.7418 118.579 10.2633 119.862C7.43063 121.327 3.1867 125.312 3.89486 128.61C4.60302 131.907 13.8091 154.988 7.43564 165.979C1.06223 176.97 0 179.901 0 179.901L15.5794 171.475C15.5794 171.475 27.6181 163.781 26.5559 159.018C25.4936 154.255 22.0752 116.52 22.0752 116.52Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 116.52C36.1201 116.52 43.5515 117.252 43.9056 117.985C44.2597 118.718 55.0591 121.832 54.3509 125.129C53.6428 128.426 43.9056 157.919 48.1546 163.415C52.4035 168.91 59.4851 176.604 57.0065 177.336C54.528 178.069 50.279 176.237 46.0301 177.336C41.7812 178.436 31.867 169.276 32.9292 159.384C33.9914 149.493 32.9375 119.084 36.1201 116.52Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0875 165.559C20.0875 165.559 11.088 166.29 12.4254 170.146C13.7629 174.001 19.7786 173.786 21.0045 173.052C22.2305 172.318 20.0875 165.559 20.0875 165.559Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4796 102.781C39.8708 102.781 40.1878 102.124 40.1878 101.315C40.1878 100.506 39.8708 99.8496 39.4796 99.8496C39.0885 99.8496 38.7715 100.506 38.7715 101.315C38.7715 102.124 39.0885 102.781 39.4796 102.781Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.589 102.781C18.9801 102.781 19.2972 102.124 19.2972 101.315C19.2972 100.506 18.9801 99.8496 18.589 99.8496C18.1979 99.8496 17.8809 100.506 17.8809 101.315C17.8809 102.124 18.1979 102.781 18.589 102.781Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6761 121.282C45.6761 121.282 52.7527 121.282 54.174 124.946C55.5853 136.165 50.0971 156.132 48.3267 159.796C42.1303 174.45 21.0626 173.351 21.0626 173.351C21.0626 173.351 21.2397 166.757 20.3545 166.757L39.3027 154.622L45.6761 121.282Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3305 122.381C11.3305 122.381 2.47852 124.213 2.47852 129.709C2.47852 132.552 5.1154 160.123 13.2729 168.039C22.833 169.504 33.8094 165.841 34.5176 164.925C36.288 164.925 35.4028 158.696 35.4028 156.865C35.4028 156.061 19.7121 158.696 19.7121 158.696C15.7959 141.556 11.3305 122.381 11.3305 122.381Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.2778 133.189L21.2446 165.426C21.2446 165.426 17.5268 137.219 13.2778 133.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.2659 128.659L36.2085 170.807C36.2085 170.807 38.7837 131.09 44.2659 128.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0344 112.123C34.7054 112.123 39.3027 107.366 39.3027 101.498C39.3027 95.6304 34.7054 90.8735 29.0344 90.8735C23.3634 90.8735 18.7661 95.6304 18.7661 101.498C18.7661 107.366 23.3634 112.123 29.0344 112.123Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4455 90.6895L30.7704 86.5298L20.1718 88.2316L17.979 98.2528L23.4375 98.0355L24.9625 94.3539V97.9751L27.4814 97.8747L28.943 92.0132L29.8569 98.2528L38.8112 98.0638L38.4455 90.6895Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58 163.674H39.1207C39.1207 163.674 47.2646 165.506 46.9105 159.644C46.5564 153.782 36.9963 157.446 36.9963 157.446L33.8096 157.812L35.58 163.674Z",
    fill: "#FFB8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 297,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCandidateApplicationsFound);
export default __webpack_public_path__ + "static/media/no-candidate-applications-found.2c8d1cfa.svg";
export { ForwardRef as ReactComponent };